<template>
  <div class="exam-record">
    <!-- 如果 faceshow 为 false，显示考试记录列表 -->
    <el-card v-if="!faceshow">
      <h2>考试记录</h2>
      <el-table :data="examRecords" border style="width: 100%">
        <el-table-column prop="planName" label="考试名称" width="300"></el-table-column>
        <el-table-column prop="score" label="成绩" width="100"></el-table-column>

        <!-- 状态列 -->
        <el-table-column prop="status" label="状态" width="150">
          <template #default="scope">
            <el-tag :type="scope.row.status === 1 ? 'success' : (isExamNotAllowed(scope.row) ? 'danger' : 'warning')">
              {{ getStatusText(scope.row) }}
            </el-tag>
          </template>
        </el-table-column>

        <!-- 开始时间和结束时间 -->
        <el-table-column label="开始时间" width="180">
          <template #default="scope">
            {{ scope.row.startDate }}
          </template>
        </el-table-column>
        <el-table-column label="结束时间" width="180">
          <template #default="scope">
            {{ scope.row.endDate }}
          </template>
        </el-table-column>

        <!-- 操作列 -->
        <el-table-column label="操作" width="180">
          <template #default="scope">
            <el-button
                :disabled="scope.row.status === 1 || isExamNotAllowed(scope.row)"
                @click="joinExam(scope.row)"
                type="primary"
            >
              {{ scope.row.status === 0 && !isExamNotAllowed(scope.row) ? '参加考试' : '无法参加' }}
            </el-button>

            <!-- 查看试卷按钮 -->
            <el-button
                v-if="scope.row.status === 1"
                @click="viewExamPaper(scope.row)"
                type="success"
                size="small"
                style="margin-left: 10px;"
            >
              查看试卷
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 如果 faceshow 为 true，显示人脸识别组件 -->
    <el-card v-else>
      <face :userid="userid" @close="onFaceRecognitionClose"></face>
    </el-card>

    <!-- 查看试卷弹窗 -->

    <el-dialog
       v-model="dialogVisible"
        title="试卷内容"
        width="60%"
        :before-close="handleClose"
    >
      <div v-if="examPaper">
        <h3>试卷内容：</h3>
        <div v-for="(question, index) in examPaper" :key="index" >
          <p><strong>{{ index + 1 }}. {{ question.question }}</strong></p>
          <p><strong>答案：</strong>{{ question.answer }}</p>
          <p><strong>我的答案：</strong>{{ showingmyanser[question.id] || '未作答' }}</p>


          <!-- 使用行内样式实现得分和回答状态的布局 -->
          <p style="display: inline-block; width: 45%;"><strong>得分：</strong>{{ question.score }}</p>
          <p style="display: inline-block; width: 45%; text-align: right;">
            <strong>回答状态：</strong>
            <span :style="{ color: question.isCorrect ? 'green' : 'red' }">
      {{ question.isCorrect ? '正确' : '错误' }}
    </span>
          </p>




          <p v-if="question.options"><strong>选项：</strong>{{ question.options }}</p>
        </div>
      </div>
      <div v-else>
        <p>正在加载试卷...</p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from '@/axios'
import { ElMessage, ElDialog } from "element-plus";
import face from '@/components/FaceGet.vue'

export default {
  components: {
    face
  },
  props: {
    userid: {
      type: Number,
      required: true
    },
    organizationID: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      examRecords: [],
      faceshow: false,  // 控制人脸识别显示
      currentPage: 1,
      pageSize: 10,
      Exams: null,
      dialogVisible: false,  // 控制弹出框显示
      examPaper: null , // 存储试卷内容
      showingExam: null,
      showingmyanser:[]
    };
  },

  methods: {
    // 判断考试是否可以参加
    isExamNotAllowed(exam) {
      const currentDate = new Date();
      const startDate = new Date(exam.startDate);
      const endDate = new Date(exam.endDate);
      return currentDate < startDate || currentDate > endDate;
    },

    // 获取考试状态的文本
    getStatusText(exam) {
      if (exam.status === 1) {
        return '已通过';
      }
      if (this.isExamNotAllowed(exam)) {
        if (exam.startDate > new Date()) {
          return '未开始';
        } else {
          return '已过期';
        }
      }
      return '未参加';
    },

    // 点击“参加考试”按钮后，开始进行人脸识别
    joinExam(exam) {
      this.Exams = exam;
      axios.get('/user-watch-history/isover', { params: { userid: this.userid, planid: exam.training_plan_id } })
          .then(res => {
            if (res.data.success) {
              // 显示人脸识别组件
              this.faceshow = true;
            } else {
              ElMessage.error(res.data.errorMsg);
            }
          })
          .catch(error => {
            ElMessage.error('请求失败');
          });
    },

    // 人脸识别完成后的处理
    onFaceRecognitionClose(isRecognized) {
      alert('识别结果：' + isRecognized)
      if (isRecognized) {
        // 人脸识别成功，跳转到考试页面
        this.$router.push({
          name: 'AnserView',
          query: {
            questions: JSON.stringify(this.examRecords.find(exam => exam.examId === this.Exams.examId).questionAnswers),
            examid: this.Exams.examId,
            userid: this.userid,
            organizationID: this.organizationID
          }
        });
      }
      // 关闭人脸识别组件
      this.faceshow = false;
    },

    // 查看试卷按钮点击事件
    viewExamPaper(exam) {

      // examUserId

      var find = this.examRecords.find(examRecord=>examRecord.examUserId === exam.examUserId);
      console.log(find)
      // console.log(exam)
this.showingExam=exam.examUserId
      this.examPaper=find.questionAnswers
      console.log('展示   '+ find.examUserId)
      // 解析我的答案
      if (find.myanser) {
        this.showingmyanser = JSON.parse(find.myanser); // 假设 myAnswer 是一个 JSON 字符串
      }
      else {
        this.showingmyanser = {};
      }
      // console.log(this.showingmyanser)
      // console.log(find.myanser)

      // 计算得分
      this.examPaper.forEach(question => {
        const userAnswer = this.showingmyanser[question.id];
        question.isCorrect = userAnswer === question.answer; // 判断是否正确
        question.score = question.isCorrect ? question.score : 0;  // 如果正确，得分；否则为 0
      });
      this.dialogVisible = true;  // 显示弹出框
    },

    // 关闭弹出框时的处理
    handleClose(done) {
      this.examPaper = null;  // 清空试卷内容
      done();
    }
  },

  created() {
    // 获取考试记录
    axios.get('/Exam', { params: { userid: this.userid } })
        .then(response => {
          this.examRecords = response.data.data;
        })
        .catch(error => {
          ElMessage.error('获取考试记录失败');
        });
  }
};
</script>

<style scoped>
.exam-record {
  padding: 20px;
}
</style>
